import { DECIMAL_PRECISION, FORMAT_TEMPLATES } from '#shared/constants/foundation'

export const GRID_BREAKPOINTS = {
  SMALL_MAX_ITEMS: 4,
  MEDIUM_MAX_ITEMS: 6,
  LARGE_MAX_ITEMS: 8,
} as const

export const GRID_CSS_CLASSES = {
  FOUR_COLUMN_RESPONSIVE: 'grid-cols-1 sm:grid-cols-2 md:grid-cols-4',
  THREE_COLUMN_RESPONSIVE: 'grid-cols-1 sm:grid-cols-2 md:grid-cols-3',
} as const

export const DECIMAL_PLACES = {
  APY_PERCENTAGE: DECIMAL_PRECISION.APY_PERCENTAGE_DECIMALS,
  USD_AMOUNT: DECIMAL_PRECISION.CURRENCY_DECIMALS,
  DEFAULT_TOKEN_DECIMALS: DECIMAL_PRECISION.USDC_DECIMALS,
} as const

export { FORMAT_TEMPLATES }

export const DASHBOARD_LABELS = {
  VAULT_APY: 'Vault APY',
  TOTAL_DEPOSITS: 'Total Deposits',
  MEMBER_DEPOSITS: 'Member Deposits',
  SPONSOR_DEPOSITS: 'Sponsor Deposits',
  ACCRUED_REWARDS: 'Accrued Rewards',
  TOTAL_MEMBERS: 'Total Members',
  AUTO_INSURANCE: 'Auto Insurance',
  HOME_INSURANCE: 'Home Insurance',
  RENTERS_INSURANCE: 'Renters Insurance',
  BRONZE_TIER_MEMBERS: 'Bronze Tier Members',
  SILVER_TIER_MEMBERS: 'Silver Tier Members',
  GOLD_TIER_MEMBERS: 'Gold Tier Members',
} as const

export const DASHBOARD_COLORS = {
  VAULT_APY: 'text-accent-2',
  TOTAL_DEPOSITS: 'text-accent',
  MEMBER_DEPOSITS: 'text-accent',
  SPONSOR_DEPOSITS: 'text-accent',
  ACCRUED_REWARDS: 'text-accent',
  TOTAL_MEMBERS: 'text-accent-2',
  INSURANCE_TIERS: 'text-accent-2',
} as const

export const DASHBOARD_DEFAULTS = {
  FALLBACK_COUNT: 0,
  DEV_MODE_ENABLED: false,
  IS_DEV: false,
} as const
